import gql from 'graphql-tag';

export const ListContactsQuery = gql`
  query ListContactsQuery {
    contacts {
      id
      jobTitle
      fullName
      firstName
      lastName
      emailAddress1
      emailAddress2
      telephone1
      telephone1sms
      telephone2
      telephone2sms
      address1_Line1
      address1_Line2
      address1_City
      address1_StateOrProvince
      address1_PostalCode
      familyStatusCode
      isContractor
      isEngineer
      isHomeowner
      isInspector
    }
  }
`;

export const GetCurrentContact = gql`
         query GetContactQuery {
           contact {
             id
             jobTitle
             fullName
             firstName
             lastName
             isContractor
             isEngineer
             isHomeowner
             isInspector
             emailAddress1
             emailAddress2
             telephone1
             telephone1sms
             telephone2
             telephone2sms
             address1_Line1
             address1_Line2
             address1_City
             address1_StateOrProvince
             address1_PostalCode
             familyStatusCode
             businessName
             address2_Telephone1
             address2_Line1
             address2_Line2
             address2_City
             address2_StateOrProvince
             address2_PostalCode
             address2_Latitude
             address2_Longitude
             address3_Line1
             address3_Line2
             address3_City
             address3_StateOrProvince
             address3_PostalCode
             address3_Latitude
             address3_Longitude
             webSiteUrl
             contractorLicenseNumber
             contractorLicenseExpiration
             contractorInDirectory
             essContractorInDirectory
             emrContractorInDirectory
             advertiseYourself
             femaTrained
             essFemaTrained
             emrFemaTrained
             personalizationDashboardHome
           }
         }
       `;

export const GetContactByIdQuery = gql`
         query GetContactQuery($id: String, $resetCache: Boolean) {
           contact(id: $id, resetCache: $resetCache) {
             id
             jobTitle
             fullName
             firstName
             lastName
             isContractor
             isEngineer
             isHomeowner
             isInspector
             emailAddress1
             emailAddress2
             telephone1
             telephone1sms
             telephone2
             telephone2sms
             address1_Line1
             address1_Line2
             address1_City
             address1_StateOrProvince
             address1_PostalCode
             familyStatusCode
             businessName
             address2_Telephone1
             address2_Line1
             address2_Line2
             address2_City
             address2_StateOrProvince
             address2_PostalCode
             address2_Latitude
             address2_Longitude
             address3_Line1
             address3_Line2
             address3_City
             address3_StateOrProvince
             address3_PostalCode
             address3_Latitude
             address3_Longitude
             webSiteUrl
             contractorLicenseNumber
             contractorLicenseExpiration
             contractorInDirectory
             essContractorInDirectory
             emrContractorInDirectory
             advertiseYourself
             femaTrained
             essFemaTrained
             emrFemaTrained
             personalizationDashboardHome
             dashboardTour
             contractorLicenseIsValid
             hasReview
             achOptInOrOut
             achAuthorizationDate
             _Ebb_AchPaymentId
              achPayment {
               payeeName
            }
           }
         }
       `;

export const CheckContractorLicense = gql`
  query CheckContractorLicense($licenseNumber: String) {
    checkContractorLicense(licenseNumber: $licenseNumber) {
      id
      salutation
      jobTitle
      fullName
      firstName
      lastName
      isContractor
      isEngineer
      isHomeowner
      isInspector
      emailAddress1
      emailAddress2
      telephone1
      telephone1sms
      telephone2
      telephone2sms
      address1_Line1
      address1_Line2
      address1_City
      address1_StateOrProvince
      address1_PostalCode
      familyStatusCode
      businessName
      address2_Telephone1
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      address2_Latitude
      address2_Longitude
      address3_Line1
      address3_Line2
      address3_City
      address3_StateOrProvince
      address3_PostalCode
      address3_Latitude
      address3_Longitude
      webSiteUrl
      contractorLicenseNumber
      contractorLicenseExpiration
      contractorInDirectory
      essContractorInDirectory
      emrContractorInDirectory
      advertiseYourself
      femaTrained
      essFemaTrained
      emrFemaTrained
      personalizationDashboardHome
      dashboardTour
      isSameas_BusinessAddress
      howdidyouhearaboutusType
      howdidyouhearaboutusOther
     }
  }
`;
export const CheckLDPLicense = gql`
  query CheckLDPLicense($licenseNumber: String) {
    checkLdpLicense(licenseNumber: $licenseNumber) {
      id
      fullName
      firstName
      lastName
      emailAddress1
      emailAddress2
      telephone1
      telephone1sms
      telephone2
      telephone2sms
      address1_Line1
      address1_Line2
      address1_City
      address1_StateOrProvince
      address1_PostalCode
      isEngineer
      ldpLicenseType
      ldpLicenseNumber
      ldpLicenseExpiration
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      webSiteUrl
      ldpManualEntry
      address2_Telephone1
    }
  }
`;

export const ContactExistsQuery = gql`
  query contactExists($email: String) {
    contactExists(email: $email)
  }
`;

export const ContactExistsDetailsQuery = gql`
  query contactExistsDetail($email: String,$recaptchaToken: String) {
    contactExistsDetail(email: $email,recaptchaToken: $recaptchaToken) {
      isEbbLegacy
      isVerified
      hasB2c
      isDebar
      isContractor
    	isHomeowner
    	isEngineer
    }
  }
`;
export const contactLdpExistsDetail = gql`
  query contactLdpExistsDetail($email: String) {
    contactLdpExistsDetail(email: $email){
      isEbbLegacy
      isVerified
      hasB2c
      isDebar
      isContractor
    	isHomeowner
    	isEngineer
    }
  }
`;
export const GetLdpByIdQuery = gql`
  query GetLdpByIdQuery($id: String, $resetCache:Boolean){
    getldpcontact(id: $id, resetCache: $resetCache) {
      id
      fullName
      businessName
      emailAddress1
      emailAddress2
      telephone1
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      address2_Telephone1
      address2_Latitude
      address2_Longitude
      webSiteUrl
      ldpLicenseNumber
      ldpLicenseExpiration
      ldpLicenseType
      hasReview
      ldpManualEntry
    }
  }
`;
